import { render, staticRenderFns } from "./sign-up-link.vue?vue&type=template&id=457a34c6&scoped=true&lang=pug&"
import script from "./sign-up-link.vue?vue&type=script&lang=js&"
export * from "./sign-up-link.vue?vue&type=script&lang=js&"
import style0 from "./sign-up-link.vue?vue&type=style&index=0&id=457a34c6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a34c6",
  null
  
)

export default component.exports